export const italic = `
font-family: 'mr-eaves-sans', 'mr-eaves-modern', cursive;
font-style: italic;`;



// WEBPACK FOOTER //
// ./src/constants/styles.js